import { curry, pipe } from 'rambda';
import Constant from 'constants';
import APP from 'app';
import clientConfigDekorator from "services/decorator/configuration/clientConfig";
import connector from "services/connect/genericConnector";
/**
 * Service for dispatching config and caching update events
 */
class TokenService {

    dispatchEvent = (updatedTokens = [], newTokens = {}) => {
        const then = curry((f, p) => p.then(f));
        const _whiteLabelConfig = `${APP.Utils.getWhitelabelKey()}_${Constant.module.CACHE_TOKENS.HOTEL_CONFIG}`;

        updatedTokens.forEach(async (token) => {
            switch (token) {
                case Constant.module.CACHE_TOKENS.HOTEL_CONFIG: {
                    const data = {
                        api: 'getDocuments',
                        content: {
                            "key": "CLIENT_CONFIGURATION_HOTEL"
                        }
                    };
                    const response = await pipe(connector, then(clientConfigDekorator))(data);
                    return response;
                }
                case _whiteLabelConfig: {
                    const data = {
                        api: 'getDocuments',
                        content: {
                            "key": `CLIENT_CONFIGURATION_HOTEL_${APP.Utils.getWhitelabelKey()}`
                        }
                    };
                    const response = await pipe(connector, then(clientConfigDekorator))(data);
                    return response;
                }
                default:
                    return false;
            }
        })
    }
}

const tokenService = new TokenService();

Object.freeze(tokenService);

export default tokenService;